export const isProd = process.env.VUE_APP_ENV === "prod";
export const isPreProd = process.env.VUE_APP_ENV === "preprod";
export const isCdt = process.env.VUE_APP_ENV === "cdt";
const isDev = process.env.VUE_APP_ENV === "dev";

export const SFDC_SCOPE = isProd
  ? "api://a85fe06e-7606-4ab9-baa4-644ade3680fa/APIScope"
  : "api://e0070f37-343a-49b4-a891-031248947a5b/APIScope";

export const DATA_SCOPE = isProd
  ? "api://31870e6f-1a10-41ae-8f3d-56b3f7cc3976/APIScope"
  : "api://1905df87-2ca8-4b15-9974-784713f62583/APIScope";

// Constants for the Application
export const LOGIN_REQUEST_SCOPES = {
  scopes: ["openid", "profile"],
};

export const SILENT_TOKEN_REFRESH_SCOPES = (currentAccount) => ({
  scopes: ["openid", "profile"],
  account: currentAccount,
  forceRefresh: false,
});

export const defaultShipmentOptions = [];

export const Tenant = "05d75c05-fa1a-42e7-9cf1-eb416c396f2d";

export const CLIENT_ID = isProd
  ? "53ff88f5-6cdb-45ea-a007-4ff482cf0340"
  : "efa03a75-b915-4944-828c-545f41c88452";

export const CLIENT_ID_FOR_SOA = "93b27d5a-d38b-4822-b38b-6058190a46a2";

export const Redirect_Uri = isProd
  ? "https://disputes-agent.maersk-digital.net/"
  : isPreProd
  ? "https://disputes-agent.preprod.maersk-digital.net/"
  : isCdt
  ? "https://disputes-agent.cdt.maersk-digital.net/"
  : isDev
  ? "https://disputes-agent.dev.maersk-digital.net/"
  : "http://localhost:3000/";

export const REDIRECT_GAM_URI = isProd
  ? "https://atomportal.maersk-digital.net/"
  : isPreProd
  ? "https://atomportal.preprod.maersk-digital.net/"
  : isCdt
  ? "https://atomportal.cdt.maersk-digital.net/"
  : "https://atomportal.dev.maersk-digital.net/";

export const LOCATION_API_CONSUMER_KEY = isProd
  ? "heRPSMXlKsM5OoEqWsGBWGYwaz020xGD"
  : "oE3O8bIoMaUsXWbL8YfGZFWNxIe2JOWz";

export const APIGEE_CLIENT_KEY_ACCOUNT = "7WBGl0wkXY0jRT6axqxvCPjmp4FQKB6v";

export const APIGEE_CLIENT_KEY_DISPUTE = "yXzKQAb6WCap5UAvRunAvH6FPStS9P2G";

export const APIGEE_CLIENT_KEY_SFDC = "bzUXKHfCCcV7ELZSLQRbzpu2K2hnSYsr";

export const APIGEE_CLIENT_KEY_DATA = "2W0TNhZH5d5DyZhgNF45VTobYF7NbgVG";

export const APIGEE_CLIENT_KEY_SOA = "HO6wfZDTQ7AGdyfKvFxkpKAhAycamAau";

export const dashboardSortOptions = [
  { value: "Recently Updated", label: "Recently Updated" },
  { value: "Oldest First", label: "Oldest First" },
  { value: "Dispute Status", label: "Dispute Status" },
];

export const detailsTabItems = [
  { title: "Comments", id: "comments", active: true, icon: "comments" },
  //{ title: "Dispute information", id: "case", icon: "info-circle" },
  { title: "Case information", id: "case-information", icon: "info-circle" },
  { title: "Shipment information", id: "shipment-info", icon: "vessel-front" },
  //{ title: "DND invoices", id: "dnd-invoices", icon: "receipt" },
  // Shipment Notes is not part of the First Release
  // { title: "Shipment notes", id: "shipment-notes", icon: "book-open" },
  { title: "Disputed charges", id: "disputed-charges", icon: "book-open" },

  {
    title: "Surcharge Emails",
    id: "surcharge-emails",
    icon: "envelope",
  },
  {
    title: "Auto Resolution details",
    id: "auto-resolution-details",
    icon: "square-arrow-up-right",
  },
  {
    title: "Auto Gam Resolution",
    id: "auto-gam-resolution",
    icon: "square-arrow-up-right",
  },
  { title: "Attachments", id: "attachments", icon: "file" },
  { title: "Dispute with voice", id: "dispute-with-voice", icon: "megaphone" },
  {
    title: "Dispute traces (SAP)",
    id: "dispute-traces",
    icon: "arrows-down-up",
  },
  { title: "Activities", id: "activities", icon: "clock" },
];

export const disputeListViewBulkDropdownOptions = [
  {
    value: "",
    label: "Select Action",
    disabled: false,
  },
  {
    value: "Update_assignee",
    label: "Update dispute assignee",
    disabled: false,
  },
  {
    value: "Update_casedetails",
    label: "Update dispute case details",
    disabled: false,
  },
  {
    value: "Update_tender",
    label: "Update dispute tender",
    disabled: false,
  },
  {
    value: "Update_voice_dispute_bulk",
    label: "Update dispute with voice form",
    disabled: false,
  },
  {
    value: "Update_contact_details",
    label: "Update contact details",
    disabled: false,
  },
];

export const detailsShipmentNotesReasonType = [
  { value: "Product", label: "Product" },
];

export const constantFieldsforUpdateDispute = `REASON,CATEGORY,OUTCOME,DISPUTE_VOICE_OUTCOME,CONTRACT_CORRECTION`;

export const MANUAL_SURCHARGE_AUTO_RESOLUTION_ALGO_NAME =
  "MANUAL_SURCHARGES_UPSTREAM_CORRECTION";
export const AUTO_RESOLUTION_OUTCOME_POTENTIAL_REJECT = "Potential Reject";

export const tableActionColumns = [
  {
    title: "Checkbox",
    slotKey: "checkbox",
    width: 48,
    isFrozen: true,
    type: "checkbox",
    sortable: true,
  },
];

export const configColumns = [
  {
    title: "OHP Dispute id",
    slotKey: "ohpDisputeId",
    width: 160,
    isFrozen: true,
    sortable: true,
  },
  {
    title: "Dispute type",
    slotKey: "disputeType",
    width: 140,
    sortable: true,
  },
  {
    title: "Invoice number",
    slotKey: "invoiceNumber",
    width: 160,
    isFrozen: true,
    sortable: true,
  },
  {
    title: "Tp doc number",
    slotKey: "tpDocumentNumber",
    width: 160,
    sortable: true,
  },
  {
    title: "Assignee",
    slotKey: "disputeAgentName",
    width: 160,
    sortable: true,
  },
  {
    title: "Processor Name",
    slotKey: "processorName",
    width: 140,
    sortable: true,
  },
  {
    title: "Dispute Voice Agent",
    slotKey: "ohpDisputeVoiceAgent",
    width: 140,
    sortable: true,
  },
  {
    title: "Customer",
    slotKey: "customer",
    width: 140,
    sortable: true,
  },
  {
    title: "Carrier",
    slotKey: "carrier",
    width: 160,
    sortable: true,
  },
  {
    title: "Is tender",
    slotKey: "isTender",
    width: 120,
    sortable: true,
  },
  {
    title: "Is Fmc",
    slotKey: "isFmcRegulated",
    width: 120,
    sortable: true,
  },
  {
    title: "Is Spot",
    slotKey: "isSpot",
    width: 120,
    sortable: true,
  },
  {
    title: "Is redispute",
    slotKey: "isRedisputed",
    width: 140,
    sortable: true,
  },
  {
    title: "Is SLA Missed",
    slotKey: "isSLAMissed",
    width: 140,
  },
  {
    title: "Charge type",
    slotKey: "chargeCode",
    width: 140,
    sortable: true,
  },
  {
    title: "Area",
    slotKey: "areaName",
    width: 200,
    sortable: true,
  },
  {
    title: "Reason",
    slotKey: "reasonDescription",
    width: 120,
    sortable: true,
  },
  {
    title: "Root Cause",
    slotKey: "rootCauseDescription",
    width: 160,
    sortable: true,
  },
  {
    title: "Created at",
    slotKey: "createdTs",
    width: 180,
    sortable: true,
    type: "date",
  },
  {
    title: "Last updated at",
    slotKey: "changedTs",
    width: 180,
    type: "date",
    sortable: true,
  },
  {
    title: "Closed at",
    slotKey: "closedTs",
    width: 160,
    type: "date",
    sortable: true,
  },
  {
    title: "Last Dispute Timestamp",
    slotKey: "lastDisputeTs",
    width: 160,
    type: "date",
    sortable: true,
  },
  {
    title: "Case Aging",
    slotKey: "case_aging",
    width: 180,
    isFrozen: true,
  },
  {
    title: "Resolution Time",
    slotKey: "resolutionTat",
    width: 140,
    isFrozen: true,
  },
  {
    title: "Gsc",
    slotKey: "gsc",
    width: 120,
    sortable: true,
  },
  {
    title: "Region name",
    slotKey: "regionName",
    width: 120,
    sortable: true,
  },
  {
    title: "Outcome",
    slotKey: "disputeOutcomeDescription",
    width: 120,
    sortable: true,
  },
  {
    title: "Redisputed count",
    slotKey: "redisputeCount",
    width: 160,
    sortable: true,
  },
  {
    title: "Price owner name",
    slotKey: "priceOwnerName",
    width: 200,
    sortable: true,
  },
  {
    title: "Price owner code",
    slotKey: "priceOwnerScvCode",
    width: 160,
    sortable: true,
  },
  {
    title: "Dispute stage",
    slotKey: "disputeStage",
    width: 160,
    sortable: true,
  },
  {
    title: "Dispute status",
    slotKey: "statusDescription",
    width: 340,
    sortable: true,
  },
];

export const defaultColumns = [
  {
    title: "OHP Dispute id",
    slotKey: "ohpDisputeId",
    width: 160,
    isFrozen: true,
    sortable: true,
  },
  {
    title: "Dispute type",
    slotKey: "disputeType",
    width: 140,
    sortable: true,
  },
  {
    title: "Invoice number",
    slotKey: "invoiceNumber",
    width: 160,
    sortable: true,
  },
  {
    title: "ODN",
    slotKey: "odn",
    width: 200,
    sortable: true,
  },
  {
    title: "Tp doc number",
    slotKey: "tpDocumentNumber",
    width: 160,
    sortable: true,
  },
  {
    title: "Assignee",
    slotKey: "disputeAgentName",
    width: 160,
    sortable: true,
  },
  {
    title: "Processor Name",
    slotKey: "processorName",
    width: 140,
    sortable: true,
  },
  {
    title: "Dispute Voice Agent",
    slotKey: "ohpDisputeVoiceAgent",
    width: 140,
    sortable: true,
  },
  {
    title: "Customer",
    slotKey: "customer",
    width: 140,
    sortable: true,
  },
  {
    title: "Carrier",
    slotKey: "carrier",
    width: 160,
    sortable: true,
  },
  {
    title: "Is tender",
    slotKey: "isTender",
    width: 120,
    sortable: true,
  },
  {
    title: "Is Fmc",
    slotKey: "isFmcRegulated",
    width: 120,
    sortable: true,
  },
  {
    title: "Is Spot",
    slotKey: "isSpot",
    width: 120,
    sortable: true,
  },
  {
    title: "Is redispute",
    slotKey: "isRedisputed",
    width: 140,
    sortable: true,
  },
  {
    title: "Is SLA Missed",
    slotKey: "isSLAMissed",
    width: 140,
  },
  {
    title: "Charge type",
    slotKey: "chargeCode",
    width: 140,
    sortable: true,
  },
  {
    title: "Area",
    slotKey: "areaName",
    width: 200,
    sortable: true,
  },
  {
    title: "Reason",
    slotKey: "reasonDescription",
    width: 120,
    sortable: true,
  },
  {
    title: "Root Cause",
    slotKey: "rootCauseDescription",
    width: 160,
    sortable: true,
  },
  {
    title: "Created at",
    slotKey: "createdTs",
    width: 180,
    type: "date",
    sortable: true,
  },
  {
    title: "Last updated at",
    slotKey: "changedTs",
    width: 180,
    type: "date",
    sortable: true,
  },
  {
    title: "Closed at",
    slotKey: "closedTs",
    width: 160,
    type: "date",
    sortable: true,
  },
  {
    title: "Last Dispute Timestamp",
    slotKey: "lastDisputeTs",
    width: 160,
    type: "date",
    sortable: true,
  },
  {
    title: "Case Aging",
    slotKey: "case_aging",
    width: 180,
    isFrozen: true,
  },
  {
    title: "Resolution Time",
    slotKey: "resolutionTat",
    width: 180,
    isFrozen: true,
  },
  {
    title: "Gsc",
    slotKey: "gsc",
    width: 120,
    sortable: true,
  },
  {
    title: "Region name",
    slotKey: "regionName",
    width: 120,
    sortable: true,
  },
  {
    title: "Outcome",
    slotKey: "disputeOutcomeDescription",
    width: 120,
    sortable: true,
  },
  {
    title: "Redisputed count",
    slotKey: "redisputeCount",
    width: 160,
    sortable: true,
  },
  {
    title: "Price owner name",
    slotKey: "priceOwnerName",
    width: 200,
    sortable: true,
  },
  {
    title: "Price owner code",
    slotKey: "priceOwnerScvCode",
    width: 160,
    sortable: true,
  },
  {
    title: "Dispute stage",
    slotKey: "disputeStage",
    width: 160,
    sortable: true,
  },
  {
    title: "Dispute status",
    slotKey: "statusDescription",
    width: 340,
    sortable: true,
  },
  {
    title: "Area code",
    slotKey: "areaCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Billing Document Date",
    slotKey: "billingDocumentDate",
    width: 140,
    isVisible: false,
  },
  {
    title: "Brand",
    slotKey: "brand",
    width: 140,
    isVisible: false,
  },
  {
    title: "Business Area Code",
    slotKey: "businessAreaCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Business Area Description",
    slotKey: "businessAreaDescription",
    width: 140,
    isVisible: false,
  },
  {
    title: "Case Key",
    slotKey: "caseKey",
    width: 200,
    isVisible: false,
  },
  {
    title: "Case Title",
    slotKey: "caseTitle",
    width: 140,
    isVisible: false,
  },
  {
    title: "Case Type",
    slotKey: "caseType",
    width: 140,
    isVisible: false,
  },
  {
    title: "Category Code",
    slotKey: "categoryCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Category Description",
    slotKey: "categoryDescription",
    width: 140,
    isVisible: false,
  },
  {
    title: "Changed By",
    slotKey: "changedBy",
    width: 140,
    isVisible: false,
  },
  {
    title: "Closed By",
    slotKey: "closedBy",
    width: 140,
    isVisible: false,
  },
  {
    title: "closed Timestamp",
    slotKey: "closedDtts",
    width: 140,
    isVisible: false,
  },
  {
    title: "Company Code",
    slotKey: "companyCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Company Description",
    slotKey: "companyDescription",
    width: 140,
    isVisible: false,
  },
  {
    title: "Contact Email",
    slotKey: "contactEmail",
    width: 160,
    isVisible: false,
  },
  {
    title: "Contact Person",
    slotKey: "contactPerson",
    width: 140,
    isVisible: false,
  },
  {
    title: "Contact Tel Number",
    slotKey: "contactTelNumber",
    width: 160,
    isVisible: false,
  },
  {
    title: "Coordinator Code",
    slotKey: "coordinatorCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Country Code",
    slotKey: "countryCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Country Name",
    slotKey: "countryName",
    width: 140,
    isVisible: false,
  },
  {
    title: "Created By",
    slotKey: "createdBy",
    width: 140,
    isVisible: false,
  },
  {
    title: "Created Source",
    slotKey: "createdSource",
    width: 140,
    isVisible: false,
  },
  {
    title: "Credit Note",
    slotKey: "creditNote",
    width: 140,
    isVisible: false,
  },
  {
    title: "Customer Type",
    slotKey: "customerType",
    width: 140,
    isVisible: false,
  },
  {
    title: "Customer Name",
    slotKey: "customerName",
    width: 140,
    isVisible: true,
  },
  {
    title: "Dispute Agent Apm Id",
    slotKey: "disputeAgentApmId",
    width: 140,
    isVisible: false,
  },
  {
    title: "Dispute Agent Email",
    slotKey: "disputeAgentEmail",
    width: 140,
    isVisible: false,
  },
  {
    title: "Dispute Origin",
    slotKey: "disputeOrigin",
    width: 140,
    isVisible: false,
  },
  {
    title: "Dispute Outcome Code",
    slotKey: "disputeOutcomeCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Dispute Sub Status",
    slotKey: "disputeSubStatus",
    width: 140,
    isVisible: false,
  },
  {
    title: "Disputed Amount",
    slotKey: "disputedAmount",
    width: 140,
    isVisible: false,
  },
  {
    title: "Doc Guid",
    slotKey: "docGuid",
    width: 140,
    isVisible: false,
  },
  {
    title: "Document Type",
    slotKey: "documentType",
    width: 140,
    isVisible: false,
  },
  {
    title: "Expected Amount",
    slotKey: "expectedAmount",
    width: 140,
    isVisible: false,
  },
  {
    title: "FSCM Changed By",
    slotKey: "fscmChangedBy",
    width: 140,
    isVisible: false,
  },
  {
    title: "FSCM Closed By",
    slotKey: "fscmClosedBy",
    width: 140,
    isVisible: false,
  },
  {
    title: "FSCM Closed Timestamp",
    slotKey: "fscmClosedTs",
    width: 140,
    isVisible: false,
  },
  {
    title: "FSCM Created By",
    slotKey: "fscmCreatedBy",
    width: 140,
    isVisible: false,
  },
  {
    title: "FSCM Created Timestamp",
    slotKey: "fscmCreatedTs",
    width: 140,
    isVisible: false,
  },
  {
    title: "FSCM Opened Timestamp",
    slotKey: "fscmOpenedTs",
    width: 140,
    isVisible: false,
  },
  {
    title: "Invoice Amount",
    slotKey: "invoiceAmount",
    width: 140,
    isVisible: false,
  },
  {
    title: "ISR Raised",
    slotKey: "isrRaised",
    width: 140,
    isVisible: false,
  },
  {
    title: "No Of Containers",
    slotKey: "noOfContainers",
    width: 140,
    isVisible: false,
  },
  {
    title: "Open Timestamp",
    slotKey: "openTs",
    width: 140,
    isVisible: false,
  },
  {
    title: "Original Disputed Amount",
    slotKey: "originalDisputedAmount",
    width: 140,
    isVisible: false,
  },
  {
    title: "Payment Type",
    slotKey: "paymentType",
    width: 140,
    isVisible: false,
  },
  {
    title: "Reason Code",
    slotKey: "reasonCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Redispute Category",
    slotKey: "redisputeCategory",
    width: 140,
    isVisible: false,
  },
  {
    title: "Redispute Category Description",
    slotKey: "redisputeCategoryDescription",
    width: 140,
    isVisible: false,
  },
  {
    title: "Redispute Outcome Code",
    slotKey: "redisputeOutcomeCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Redispute Outcome Description",
    slotKey: "redisputeOutcomeDescription",
    width: 140,
    isVisible: false,
  },
  {
    title: "Redispute Root Cause Description",
    slotKey: "redisputeRootCauseDescription",
    width: 140,
    isVisible: false,
  },
  {
    title: "Reference Key",
    slotKey: "referenceKey",
    width: 140,
    isVisible: false,
  },
  {
    title: "Region Code",
    slotKey: "regionCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Root Cause Code",
    slotKey: "rootCauseCode",
    width: 140,
    isVisible: false,
  },
  {
    title: "Team Leader",
    slotKey: "teamLeader",
    width: 140,
    isVisible: false,
  },
];

export const azureActiveDirectoryGroups = {
  azureAdForProdGamAccess: "867ffc39-9a33-4e25-b276-6d208abfc23a",
  azureAdForAtomGamAccess: "34c11aa3-4736-4e53-af03-8f59dcb1aa90",
  azureAdForWaiverGamAccess: "ee015198-5da6-4eb4-9a1c-f04f76aa58aa",
  azureAdForUpdateDisputeAccess: "4ddda7ed-6731-4018-bbe8-f0881185f1ed",
  azureAdForAssigneeDisputeAccess: isProd
    ? "ca9b4ad7-10f0-45ce-a425-b7bd7af80ea4"
    : "cd753655-cc98-46b6-a5f2-c33ed623b0ca",
};

export const toolbarTextEditorValues = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ["clean"],
];

export const lookUpParameters = `COORDINATOR,ROOT_CAUSE,CURRENCY`;

export const disputeStatusList = [
  {
    id: 10,
    displayName: "10: New",
    statusId: 10,
    label: "10: New",
    value: "10: New",
    disputeCategoryName: "STATUS",
  },
  {
    id: 20,
    displayName: "20: In Process",
    statusId: 20,
    label: "20: In Process",
    value: "20: In Process",
    disputeCategoryName: "STATUS",
  },
  {
    id: 30,
    displayName: "30: Potential Reject",
    statusId: 30,
    label: "30: Potential Reject",
    value: "30: Potential Reject",
    disputeCategoryName: "STATUS",
  },
  {
    id: 60,
    displayName: "60: Accepted",
    statusId: 60,
    label: "60: Accepted",
    value: "60: Accepted",
    disputeCategoryName: "STATUS",
  },
  {
    id: 61,
    displayName: "61: Accepted - Manual Credit Note / PB",
    statusId: 61,
    label: "61: Accepted - Manual Credit Note / PB",
    value: "61: Accepted - Manual Credit Note / PB",
    disputeCategoryName: "STATUS",
  },
  {
    id: 62,
    displayName: "62: Accepted - No Change",
    statusId: 62,
    label: "62: Accepted - No Change",
    value: "62: Accepted - No Change",
    disputeCategoryName: "STATUS",
  },
  {
    id: 63,
    displayName: "63: Accepted - Invoice cancellation and rebill",
    statusId: 63,
    label: "63: Accepted - Invoice cancellation and rebill",
    value: "63: Accepted - Invoice cancellation and rebill",
    disputeCategoryName: "STATUS",
  },
  {
    id: 66,
    displayName: "66: Collectable - Rejected with evidence",
    statusId: 66,
    label: "66: Collectable - Rejected with evidence",
    value: "66: Collectable - Rejected with evidence",
    disputeCategoryName: "STATUS",
  },
  {
    id: 67,
    displayName: "67: Collectable - Rejected post validation",
    statusId: 67,
    label: "67: Collectable - Rejected post validation",
    value: "67: Collectable - Rejected post validation",
    disputeCategoryName: "STATUS",
  },
  {
    id: 68,
    displayName: "68: Accepted - Autoredisputes",
    statusId: 68,
    label: "68: Accepted - Autoredisputes",
    value: "68: Accepted - Autoredisputes",
    disputeCategoryName: "STATUS",
  },
  {
    id: 69,
    displayName: "69: Info - Autoredisputes",
    statusId: 69,
    label: "69: Info - Autoredisputes",
    value: "69: Info - Autoredisputes",
    disputeCategoryName: "STATUS",
  },
  {
    id: 70,
    displayName: "70: Collectable - Autoredisputes",
    statusId: 70,
    label: "70: Collectable - Autoredisputes",
    value: "70: Collectable - Autoredisputes",
    disputeCategoryName: "STATUS",
  },
  {
    id: 71,
    displayName: "71: Collectable - Customer Agreement",
    statusId: 71,
    label: "71: Collectable - Customer Agreement",
    value: "71: Collectable - Customer Agreement",
    disputeCategoryName: "STATUS",
  },
  {
    id: 72,
    displayName: "72: Collectable - Customer Disagrees",
    statusId: 72,
    label: "72: Collectable - Customer Disagrees",
    value: "72: Collectable - Customer Disagrees",
    disputeCategoryName: "STATUS",
  },
  {
    id: 73,
    displayName: "73: Collectable - Missing / Incomplete Info",
    statusId: 73,
    label: "73: Collectable - Missing / Incomplete Info",
    value: "73: Collectable - Missing / Incomplete Info",
    disputeCategoryName: "STATUS",
  },
  {
    id: 74,
    displayName: "74: Collectable - Waiver Approved",
    statusId: 74,
    label: "74: Collectable - Waiver Approved",
    value: "74: Collectable - Waiver Approved",
    disputeCategoryName: "STATUS",
  },
  {
    id: 78,
    displayName: "78: Collectable - Not a dispute",
    statusId: 78,
    label: "78: Collectable - Not a dispute",
    value: "78: Collectable - Not a dispute",
    disputeCategoryName: "STATUS",
  },
  {
    id: 75,
    displayName: "75: Redisputed",
    statusId: 75,
    label: "75: Redisputed",
    value: "75: Redisputed",
    disputeCategoryName: "STATUS",
  },
  {
    id: 79,
    displayName: "79: Collectable - No Response",
    statusId: 79,
    label: "79: Collectable - No Response",
    value: "79: Collectable - No Response",
    disputeCategoryName: "STATUS",
  },
];

export const disputeStatusMapping = {
  10: "10: New",
  20: "20: In Process",
  30: "30: Potential Reject",
  60: "60: Accepted",
  61: "61: Accepted - Manual Credit Note / PB",
  62: "62: Accepted - No Change",
  63: "63: Accepted - Invoice cancellation and rebill",
  66: "66: Collectable - Rejected with evidence",
  67: "67: Collectable - Rejected post validation",
  68: "68: Accepted - Autoredisputes",
  69: "69: Info - Autoredisputes",
  70: "70: Collectable - Autoredisputes",
  71: "71: Collectable - Customer Agreement",
  72: "72: Collectable - Customer Disagrees",
  73: "73: Collectable - Missing / Incomplete Info",
  74: "74: Collectable - Waiver Approved",
  78: "78: Collectable - Not a dispute",
  75: "75: Redisputed",
  79: "79: Collectable - No Response",
};

export const statusCodesForCreateGamRequest = [
  "60",
  "61",
  "62",
  "63",
  "66",
  "67",
  "68",
  "69",
  "70",
  "71",
  "72",
  "73",
  "74",
  "78",
  "79",
];

export const cacheNames = {
  filters: "disputes_filters_configuration_v2.4",
  tableConfig: "ohp_dispute_view_table_configuration_v2.3",
  //dndTableConfig: "dnd_table_configuration_v1.0",
};

export const stateToDisplayNameMapping = {
  businessArea: {
    displayName: "Business Area",
  },
  businessAreaDescription: {
    displayName: "Business Area Description",
  },
  caseKey: {
    displayName: "Case Key",
  },
  caseStatus: {
    displayName: "Case Status",
  },
  caseStatusDescription: {
    displayName: "Case status Description",
  },
  caseType: {
    displayName: "Case Type",
  },
  category: {
    displayName: "Category",
  },
  categoryDescription: {
    displayName: "Category Description",
  },
  changedOn: {
    displayName: "Changed On",
    type: "date",
  },
  chargeCode: {
    displayName: "Charge Code",
  },
  closedAt: {
    displayName: "closed At",
    type: "date",
  },
  companyCode: {
    displayName: "Company Code",
  },
  companyDescription: {
    displayName: "Company Description",
  },
  contactEmail: {
    displayName: "Contact Email",
  },
  contactFaxNumber: {
    displayName: "Contact Fax Number",
  },
  contactPerson: {
    displayName: "Contact Person",
  },
  contactTelNumber: {
    displayName: "Contact Number",
  },
  contractCorrection: {
    displayName: "Contract Correction",
  },
  coorDescription: {
    displayName: "Coor Description",
  },
  coordinator: {
    displayName: "Coordinator",
  },
  createdOn: {
    displayName: "Contact Email",
  },
  currency: {
    displayName: "Currency",
  },
  customer: {
    displayName: "Customer",
  },
  customerName: {
    displayName: "Customer Name",
  },
  disputeOrigin: {
    displayName: "Dispute Origin",
  },
  disputeOutcomeDescription: {
    displayName: "Dispute Outcome Description",
  },
  disputeOutcome: {
    displayName: "Dispute Outcome",
  },
  disputedAmount: {
    displayName: "Disputed Amount",
  },
  documentDate: {
    displayName: "Document Date",
    type: "date",
  },
  documentType: {
    displayName: "Document Type",
  },
  documentTypeDescription: {
    displayName: "Document Type Description",
  },
  fscmChangedTs: {
    displayName: "FSCM Changed Timestamp",
    type: "date",
  },
  fscmCreatedBy: {
    displayName: "FSCM Created By",
  },
  fscmCreatedTs: {
    displayName: "FSCM Created Timestamp",
    type: "date",
  },
  invoiceNumber: {
    displayName: "Invoice Number",
  },
  isFthr: {
    displayName: "Is First time handling resolution",
  },
  lastClosedAt: {
    displayName: "Last Closed At",
    type: "date",
  },
  lastDisputeDate: {
    displayName: "Last Dispute Date",
    type: "date",
  },
  ohpDisputeId: {
    displayName: "OHP Dispute Id",
  },
  openDate: {
    displayName: "Open Date",
    type: "date",
  },
  openTs: {
    displayName: "Open Timestamp",
    type: "date",
  },
  originalDisputedAmount: {
    displayName: "Original Disputed Amount",
  },
  processorName: {
    displayName: "Processor Name",
  },
  reason: {
    displayName: "Reason",
  },
  reasonDescription: {
    displayName: "Reason Description",
  },
  referenceKey: {
    displayName: "Reference Key",
  },
  rootCauseCode: {
    displayName: "Root Cause Code",
  },
  rootCauseDescription: {
    displayName: "Root Cause Description",
  },
  tpDocumentNumber: {
    displayName: "TP Document Number",
  },
  contractCorrectionDescription: {
    displayName: "Contract Correction Description",
  },
  changedBy: {
    displayName: "Changed By",
  },
  changedTs: {
    displayName: "Changed Timestamp",
    type: "date",
  },
  contactType: {
    displayName: "Contact Type",
  },
  createdBy: {
    displayName: "Created By",
  },
  createdTs: {
    displayName: "Created Timestamp",
    type: "date",
  },
  isAttemptSuccessful: {
    displayName: "Is Attempt Successful",
  },
  isCustomerAligned: {
    displayName: "Is Customer Aligned",
  },
  isDeleted: {
    displayName: "Is Deleted",
  },
  nextActionDate: {
    displayName: "Next Action Date",
    type: "date",
    format: "dateOnly",
  },
  ohpDisputeVoiceId: {
    displayName: "OHP Dispute VoiceId",
  },
  voiceOutcome: {
    displayName: "Voice Outcome",
  },
  voiceSummary: {
    displayName: "Voice Summary",
    type: "html",
  },
  expectedP2pDate: {
    displayName: "Expected P2P Date",
    type: "date",
    format: "dateOnly",
  },
};

export const voiceHistoryConfig = [
  {
    title: "Created Date",
    slotKey: "createdTs",
    width: 180,
    type: "date",
    format: "dd-MMM-yyyy hh:mm a",
  },
  {
    title: "Contact Person",
    slotKey: "contactPerson",
    width: 160,
  },
  {
    title: "Contact Email",
    slotKey: "contactEmail",
    width: 200,
  },
  {
    title: "Contact Number",
    slotKey: "contactTelNumber",
    width: 160,
  },
  {
    title: "DwV Agent",
    slotKey: "ohpDisputeVoiceAgent",
    width: 160,
  },
  {
    title: "Contact Mode",
    slotKey: "contactType",
    width: 120,
  },
  {
    title: "Attempt Successful",
    slotKey: "isAttemptSuccessful",
    width: 120,
  },
  {
    title: "Next Action Date",
    slotKey: "nextActionDate",
    width: 200,
    type: "date",
  },
  {
    title: "DWV Outcome*",
    slotKey: "voiceOutcome",
    width: 160,
  },
  {
    title: "Summary*",
    slotKey: "voiceSummary",
    width: 160,
  },
  {
    title: "Invoice Cleared Date",
    slotKey: "invoiceClearedDate",
    width: 160,
    type: "date",
  },
  {
    title: "Is Customer Aligned?*",
    slotKey: "isCustomerAligned",
    width: 160,
  },
  {
    title: "Promise to Pay",
    slotKey: "isP2PAgreed",
    width: 120,
  },
  {
    title: "P2P Date",
    slotKey: "expectedP2pDate",
    width: 200,
    type: "date",
  },
  {
    title: "P2P Amount (USD)",
    slotKey: "p2pAmountUsd",
    width: 160,
  },
  {
    title: "",
    slotKey: "more",
    field: "more",
    width: 48,
    isFrozen: true,
    frozenPosition: "right",
  },
];

export const invoiceBreakupColumns = [
  {
    title: "Charge Name",
    slotKey: "charge_name",
    width: 300,
  },
  {
    title: "Quantity",
    slotKey: "qty",
    width: 120,
  },
  {
    title: "Unit of Measure",
    slotKey: "uom",
    width: 160,
  },
  {
    title: "Rate",
    slotKey: "rate",
    width: 160,
  },
  {
    title: "Extended Value",
    slotKey: "extendedValue",
    width: 140,
  },
  {
    title: "Extended Value",
    slotKey: "extendedValue",
    width: 140,
  },
  {
    title: "Terms",
    slotKey: "terms",
    width: 120,
  },
  {
    title: "Billing Date",
    slotKey: "billingDate",
    width: 140,
  },
  {
    title: "Invoice Due Date",
    slotKey: "invoiceDueDate",
    width: 140,
  },
];

export const disputeTracesSapColumns = [
  {
    title: "Id",
    slotKey: "ohpDisputeTraceId",
    width: 160,
    isVisible: false,
  },
  {
    title: "Data",
    slotKey: "packet",
    width: 160,
  },
  {
    title: "Created at",
    slotKey: "createdTs",
    width: 160,
    type: "date",
  },
  {
    title: "Destination",
    slotKey: "destination",
    width: 160,
  },
  {
    title: "Status",
    slotKey: "status",
    width: 160,
  },
  {
    title: "Retry count",
    slotKey: "retryCount",
    width: 160,
  },
  {
    title: "Logs",
    slotKey: "logs",
    width: 500,
  },
];

export const dwvTabItems = [
  { title: "Voice history (DwV)", id: "voice_history", active: true },
];

export const chargeCode = [
  {
    id: 1,
    displayName: "100055: CY Basic Hsud",
    label: "100055: CY Basic Hsud",
    value: "100055: CY Basic Hsud",
    disputeCategoryName: "CHARGE_CODE",
  },
  {
    id: 2,
    displayName: "3DI: [US Flag] 3D Inspection",
    label: "3DI: [US Flag] 3D Inspection",
    value: "3DI: [US Flag] 3D Inspection",
    disputeCategoryName: "CHARGE_CODE",
  },
  {
    id: 3,
    displayName: "ABL",
    label: "ABL",
    value: "ABL",
    disputeCategoryName: "CHARGE_CODE",
  },
  {
    id: 4,
    displayName: "ACC",
    label: "ACC",
    value: "ACC",
    disputeCategoryName: "CHARGE_CODE",
  },
  {
    id: 5,
    displayName: "ACR: [US FLAG] ACR ROUTING SDDC",
    label: "ACR: [US FLAG] ACR ROUTING SDDC",
    value: "ACR: [US FLAG] ACR ROUTING SDDC",
    disputeCategoryName: "CHARGE_CODE",
  },
];

export const disputeBulkTabItems = [
  { title: "Completed", id: "SUCCESS", active: true },
  { title: "Failed", id: "FAILED" },
];

export const bulkDisputeSuccessColumns = [
  {
    title: "Invoice number",
    slotKey: "invoiceNumber",
    width: 180,
  },
  {
    title: "OhpDispute Id",
    slotKey: "ohpDisputeId",
    width: 240,
  },
  {
    title: "Customer Number",
    slotKey: "customer",
    width: 180,
  },
  {
    title: "Customer email id",
    slotKey: "contactEmail",
    width: 200,
  },
];

export const bulkDisputeFailedColumns = [
  {
    title: "Invoice number",
    slotKey: "invoiceNumber",
    width: 180,
  },
  {
    title: "Dispute status",
    slotKey: "statusCodeDesc",
    width: 240,
  },
  {
    title: "Failed Reason",
    slotKey: "errorMessage",
    width: 300,
  },
];

export const disputeReasons = [
  { value: "Incorrect Rates", label: "Incorrect Rates" },
  { value: "Incorrect Payer", label: "Incorrect Payer" },
  { value: "Already Paid", label: "Already Paid" },
  { value: "Missing Information", label: "Missing Information" },
  { value: "Commercial Negotiation", label: "Commercial Negotiation" },
  { value: "Legal Tagged", label: "Legal Tagged" },
  { value: "FMC Performance Bonus", label: "FMC Performance Bonus" },
  { value: "SSE Incorrect Rate", label: "SSE Incorrect Rate" },
  { value: "AFLS - Incorrect Rate", label: "AFLS - Incorrect Rate" },
  { value: "AFLS - Incorrect Payer", label: "AFLS - Incorrect Payer" },
  { value: "Short Payment", label: "Short Payment" },
  { value: "Proactive - PB", label: "Proactive - PB" },
  { value: "Legal Filed", label: "Legal Filed" },
  { value: "Third Party Audit", label: "Third Party Audit" },
];

export const ApproverInvoiceTypeList = ["Freight", "DnD"];

//UserManagement Constant
export const approverManagementConstants = {
  ACTION_RESTRICTED_MESSAGE: "Action restricted to admin",
};

export const disputeCategoryIncorrectPayer = [
  {
    id: "select",
    displayName: "Select",
    label: "Select",
    value: "",
  },
  {
    id: "2656",
    value: "Payer Dispute - GSC",
    displayName: "Payer Dispute - GSC",
    label: "2656: Payer Dispute - GSC",
    disputeCategoryName: "CATEGORY",
  },
  {
    id: "0012",
    value: "Payer Dispute - Customer",
    displayName: "Payer Dispute - Customer",
    label: "0012: Payer Dispute - Customer",
    disputeCategoryName: "CATEGORY",
  },
];

//AI model Language List

export const disputeLanguageList = [
  {
    id: 1,
    displayName: "Select a Language",
    label: "Select a Language",
    value: "Select a Language",
  },
  {
    id: 2,
    displayName: "English",
    label: "English",
    value: "English",
  },
  {
    id: 3,
    displayName: "Spanish",
    label: "Spanish",
    value: "Spanish",
  },
  {
    id: 4,
    displayName: "French",
    label: "French",
    value: "French",
  },
  {
    id: 5,
    displayName: "German",
    label: "German",
    value: "German",
  },
  {
    id: 6,
    displayName: "Italian",
    label: "Italian",
    value: "Italian",
  },
  {
    id: 7,
    displayName: "Portuguese",
    label: "Portuguese",
    value: "Portuguese",
  },
  {
    id: 8,
    displayName: "Turkish",
    label: "Turkish",
    value: "Turkish",
  },
  {
    id: 9,
    displayName: "Russian",
    label: "Russian",
    value: "Russian",
  },
  {
    id: 10,
    displayName: "Simplified Chinese",
    label: "Simplified Chinese",
    value: "Simplified Chinese",
  },
  {
    id: 11,
    displayName: "Traditional Chinese",
    label: "Traditional Chinese",
    value: "Traditional Chinese",
  },
  {
    id: 12,
    displayName: "Korean",
    label: "Korean",
    value: "Korean",
  },
  {
    id: 13,
    displayName: "Japanese",
    label: "Japanese",
    value: "Japanese",
  },
];

export const disputeOutcomesIncorrectPayer = [
  {
    id: "select",
    displayName: "Select",
    label: "Select",
    value: "",
  },
  {
    id: "002",
    value: "Duplicate / Erroneous dispute closed",
    displayName: "Duplicate / Erroneous dispute closed",
    label: "002: Duplicate / Erroneous dispute closed",
    disputeCategoryName: "OUTCOME",
  },
  {
    id: "005",
    value:
      "Information provided to customer/Customer Case Re-routed to the correct department",
    displayName:
      "Information provided to customer/Customer Case Re-routed to the correct department",
    label:
      "005: Information provided to customer/Customer Case Re-routed to the correct department",
    disputeCategoryName: "OUTCOME",
  },
  {
    id: "006",
    value: "Invoice stands correct  customer informed accordingly",
    displayName: "Invoice stands correct  customer informed accordingly",
    label: "006: Invoice stands correct  customer informed accordingly",
    disputeCategoryName: "OUTCOME",
  },
  {
    id: "009",
    value: "System amended  new invoice generated",
    displayName: "System amended  new invoice generated",
    label: "009: System amended  new invoice generated",
    disputeCategoryName: "OUTCOME",
  },
  {
    id: "012",
    value: "Customer dispute for incorrect reason",
    displayName: "Customer dispute for incorrect reason",
    label: "012: Customer dispute for incorrect reason",
    disputeCategoryName: "OUTCOME",
  },
];

export const disputeRootCauseIncorrectPayer = [
  {
    id: "select",
    displayName: "Select",
    label: "Select",
    value: "",
  },
  {
    id: "0120",
    value: "0120: Invoice logged incorrectly",
    displayName: "Invoice logged incorrectly",
    label: "0120: Invoice logged incorrectly",
    disputeCategoryName: "ROOT_CAUSE",
  },
  {
    id: "0022",
    value: "0022: Invoice Correct",
    displayName: "Invoice Correct",
    label: "0022: Invoice Correct",
    disputeCategoryName: "ROOT_CAUSE",
  },
  {
    id: "0009",
    value: "0009: Documentation - CSOP Not Followed",
    displayName: "Documentation - CSOP Not Followed",
    label: "0009: Documentation - CSOP Not Followed",
    disputeCategoryName: "ROOT_CAUSE",
  },
  {
    id: "0010",
    value: "0010: Documentation - Incorrect Consignee Updated",
    displayName: "Documentation - Incorrect Consignee Updated",
    label: "0010: Documentation - Incorrect Consignee Updated",
    disputeCategoryName: "ROOT_CAUSE",
  },
  {
    id: "0020",
    value: "0020: Customer - Incorrect Payer Details",
    displayName: "Customer - Incorrect Payer Details",
    label: "0020: Customer - Incorrect Payer Details",
    disputeCategoryName: "ROOT_CAUSE",
  },
  {
    id: "0021",
    value: "0021: Customer - TOP on SI Not Clear",
    displayName: "Customer - TOP on SI Not Clear",
    label: "0021: Customer - TOP on SI Not Clear",
    disputeCategoryName: "ROOT_CAUSE",
  },
  {
    id: "0144",
    value: "0144: Documentation: ToP DB not followed",
    displayName: "Documentation: ToP DB not followed",
    label: "0144: Documentation: ToP DB not followed",
    disputeCategoryName: "ROOT_CAUSE",
  },
  {
    id: "0011",
    value: "0011: Documentation - Shipping instruction not followed",
    displayName: "Documentation - Shipping instruction not followed",
    label: "0011: Documentation - Shipping instruction not followed",
    disputeCategoryName: "ROOT_CAUSE",
  },
  {
    id: "0020",
    value: "0020: Customer : Incorrect payer standing instructions",
    displayName: "Customer : Incorrect payer standing instructions",
    label: "0020: Customer : Incorrect payer standing instructions",
    disputeCategoryName: "ROOT_CAUSE",
  },
];

export const creditNoteFailureList = [
  {
    label: "Credit Note generate on BL",
    value: "Credit Note generate on BL",
  },
  {
    label: "Standalone Credit Note",
    value: "Standalone Credit Note",
  },
  {
    label: "Manual Credit Note with Invoice refrence",
    value: "Manual Credit Note with Invoice refrence",
  },
];
